export default __webpack_public_path__ + "static/media/movieLogo.01cf4645.png";